/**
 * Tracks "your account signed in on another device" so only PROTECTED routes
 * bounce to /auth. Public pages (home, pricing, changelog…) stay viewable after
 * the session disappears — the notice is shown on /auth only when the person
 * actually tries to open a protected page.
 */

const KICK_KEY = 'ledlogic.sessionKicked';

export function markSessionKicked(): void {
  try {
    window.sessionStorage.setItem(KICK_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function wasSessionKicked(): boolean {
  try {
    return window.sessionStorage.getItem(KICK_KEY) === '1';
  } catch {
    return false;
  }
}

/** Reads and clears the flag — used when redirecting to /auth?kicked=1. */
export function consumeSessionKicked(): boolean {
  const kicked = wasSessionKicked();
  clearSessionKicked();
  return kicked;
}

export function clearSessionKicked(): void {
  try {
    window.sessionStorage.removeItem(KICK_KEY);
  } catch {
    /* ignore */
  }
}
